<div class="wrapper">
  <div *ngIf="progress !== PharmacyManagementSystemIntegrationStepsEnum.Finish" class="info-box">
    <img src="assets/icons/icons-info-blue.svg" class="info-icon">
      <div class="">
          To complete your integration with C2 Keep, you’ll need to enter unique credentials in FrameworkLTC. 
          We'll send the information to your email next.
      </div>
  </div>

  <div *ngIf="progress !== PharmacyManagementSystemIntegrationStepsEnum.Finish" class="controls">
      <app-button customClasses="w-full"
                  text="Confirm"
                  class="next"
                  [disabled]="(loading$ | async)"
                  (clicked)="showPin()"
                  [loading]="loading$ | async" 
      >
      </app-button>
      <app-button customClasses="w-full"
                  subStyle="transparent"
                  class="back"
                  (clicked)="back.emit(PharmacyManagementSystemIntegrationStepsEnum.SelectType)"
                  [disabled]="loading$ | async"
      >
        <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
        Back
      </app-button>
    </div>

    <div *ngIf="progress === PharmacyManagementSystemIntegrationStepsEnum.Finish" 
      class="finish">
      <app-alert [show]="true"
        [autohide]="99999999"
        [type]="AlertTypesEnum.Success"
        message="Instructions have been sent to your email"
        [textFullWidth]="true"
        [hideCloseButton]="true"
      ></app-alert>
      <div class="pt-4 pb-4 font-normal text-sm"> 
        Once we start receiving your orders, we’ll notify you by email that the integration is ready to be enabled.
      </div>
      <app-button customClasses="w-full"
        text="Ok"
        (clicked)="ok.emit()"
      > 
      </app-button>
    </div>
</div>